<template>
  <div id="servis">
    <h2>Servis</h2>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
#servis {
  height: 700px;
  display: none;
}
</style>
